// src/store/services/ReporteListadoDeGestionesIngresadasPorSector.js
import feathersClient, {
    makeServicePlugin,
    BaseModel,
  } from '../../feathers-client';
  
  class ReporteListadoDeGestionesIngresadasPorSector extends BaseModel {
    constructor(data, options) {
      super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'ReporteListadoDeGestionesIngresadasPorSector';
    // Define default properties here
    static instanceDefaults() {
      return {};
    }
  }
  const servicePath = 'reporte-listado-de-gestiones-ingresadas-por-sector';
  const servicePlugin = makeServicePlugin({
    namespaced: true,
    namespace: 'ReporteListadoDeGestionesIngresadasPorSector',
    Model: ReporteListadoDeGestionesIngresadasPorSector,
    service: feathersClient.service(servicePath),
    servicePath,
  });
  
  // Setup the client-side Feathers hooks.
  feathersClient.service(servicePath).hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
  });
  
  export default servicePlugin;
  